import "./FindHome.module.css";
import MainNavigation from "@/reusable_sections/Header";
import AbileneLivingOptions from "./sections/AbileneLivingOptions";
import LeaseFlexibilityMatrix from "./sections/LeaseFlexibilityMatrix";
import OurMaintenancePromise from "./sections/OurMaintenancePromise";
import SiteFooter from "@/reusable_sections/Footer";
export default function FindHomePage() {
  return <div>
      <MainNavigation />
      <AbileneLivingOptions />
      <LeaseFlexibilityMatrix />
      <OurMaintenancePromise />
      <SiteFooter />
    </div>;
}